import React, { useState } from "react";
import creativity from "../assets/images/creativity.svg";
import trust from "../assets/images/trust1.png";
import dedication from "../assets/images/dedication1.png";
import solution from "../assets/images/solution1.png";
import client from "../assets/images/client1.png";
import integrity from "../assets/images/integrity1.png";
import "flip-card-wc";
import { motion } from "framer-motion";

const listmotion = {
  hidden: {
    opacity: 0,
    x: "-1vw",
  },
  visible: {
    opacity: 1,
    overflow: "hidden",
    x: 0,
    transition: {
      delay: 0.3,
      type: "spring",
      stiffness: "120",
    },
  },
};
const contstyles = {
  height: "18em",
  width: "16em",
  // background:`URL(${animatedbg})`,
  background: "none",
  outline: "none",
  border: "none",
  borderRadius: "1.5em",
};
const styles = {
  height: "18em",
  width: "16em",
  // background:`URL(${animatedbg})`,
  background: "#02223D",
  borderRadius: "1.5em",
};
const liststyle = {
  listStyleType: "none",
  fontWeight: "700",
  margin: "auto 0",
  padding: 0,
};
const listitemstyle = {
  width: "100%",
  color: "#fff",
  fontSize: "1rem",
  marginBottom: "0.3em",
};
const Cards = ({ title, image, desc }) => {
  const checkimage = (prop) => {
    switch (prop) {
      case "creativity":
        return creativity;
      case "trust":
        return trust;
      case "dedication":
        return dedication;
      case "client":
        return client;
      case "solution":
        return solution;
      case "integrity":
        return integrity;
    }
  };

  return (
    <div
      className="card  col-8 col-lg-3 col-md-4 mb-2 m-md-2 mx-sm-auto"
      style={contstyles}
    >
      <flip-card
        variant="hover"
        className="service-card mx-0 w-100"
        style={{ borderRadius: "1em" }}
      >
        <div
          slot="front"
          className="front card w-100 border mx-0 border-warning border-3"
          style={styles}
        >
          <img
            className="card-img-center my-auto"
            src={checkimage(image)}
            alt={image}
          />
          <h6 className="card-title align-bottom  fw-bold">{title}</h6>
        </div>
        <div
          slot="back"
          style={styles}
          className="card w-100 border border-warning border-3 p-2"
        >
          <motion.ul
            variants={listmotion}
            initial="hidden"
            animate="visible"
            style={liststyle}
            class="listitem"
          >
            {desc.map((d) => (
              <li style={listitemstyle}>
                {d}
                <br />
                <br />
              </li>
            ))}
          </motion.ul>
        </div>
      </flip-card>
    </div>
  );
};

export default Cards;
